import { globalStyle, style } from "@vanilla-extract/css";
import { breakpoints } from "plos/src/styles";
import { vars } from "plos/src/styles/theme.css";

export const COLUMN_WIDTH = 100;
export const DESKTOP_FIRST_COL_WIDTH = 160;
export const MOBILE_FIRST_COL_WIDTH = 50;

export const scrollWrapper = style({
  overflowX: "auto",
});

export const fdrTable = style({
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  fontSize: vars.fontSizes.body.s,
});

export const stickyFirstColumn = style({
  position: "sticky",
  zIndex: vars.zIndex.table.firstStickyCol,
  insetInlineStart: -1,
  background: vars.colors.surface,
  padding: `0 ${vars.space["2xs"]}`,
  width: MOBILE_FIRST_COL_WIDTH,
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      width: DESKTOP_FIRST_COL_WIDTH,
      maxWidth: DESKTOP_FIRST_COL_WIDTH,
      fontSize: vars.fontSizes.body.m,
    },
  },
});

globalStyle(`${stickyFirstColumn} > div`, {
  justifyContent: "flex-start",
});

export const eventColumn = style({
  backgroundColor: vars.colors.surface,
  padding: vars.space["2xs"],
  width: COLUMN_WIDTH,
  maxWidth: COLUMN_WIDTH,
});

export const bodyCell = style({
  padding: vars.space["2xs"],
});

export const cellWrapperStyles = style({
  display: "flex",
  height: 56,
  selectors: {
    '&[data-multiple="true"]': {
      flexDirection: "column",
      gap: 1,
    },
  },
});

export const fdrCellBorderStyles = style([
  {
    selectors: {
      "&::after": {
        position: "absolute",
        bottom: 0,
        backgroundColor: vars.colors.outlineVariant,
        width: "90%",
        height: "1px",
        content: "",
      },
    },
  },
]);

export const teamCellStyles = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: vars.space.m,
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      justifyContent: "flex-start",
    },
  },
});

export const teamCellBadge = style({
  width: "2.4rem",
  height: "2.4rem",
});

export const teamCellNameStyles = style({
  display: "none",
  marginInlineStart: vars.space["2xs"],
  fontSize: vars.fontSizes.body.s,
  "@media": {
    [`screen and (min-width: ${breakpoints[1]})`]: {
      display: "inline",
      fontSize: vars.fontSizes.body.m,
    },
  },
});
